import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContactUsService } from '../../../core/services/contact-us.service';
import { ApiResponse } from '../../../core/data-models/api-response';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, RouterModule,CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  socialMediaData: any[] = [];
  settingsData: { [key: string]: string } = {};

  constructor(private _contactUSService: ContactUsService,public  TranslateService: TranslateService) {

  }

  ngOnInit(): void {
    this.socialMedia();
    this._contactUSService.settings().subscribe({
      next: (response: ApiResponse<any>) => {
        response.data.forEach((item: any) => {
          this.settingsData[item.key] = item.value || '';
        });
      },

    });
  }


  socialMedia() {

    this._contactUSService.socialMedia().subscribe({
      next: (response: ApiResponse<any>) => {
        this.socialMediaData = response.data;

      },
      error: () => {
      }
    });
  }

}
